<template>
  <div class="ui form">
    <div class="ui" v-if="part == 1">
      <div class="ui field">
        <label>At what age do you want to retire? </label>
        <input v-model.number="timeHorizon" />
      </div>

      <div class="ui field">
        <label> Monthly Income required </label>

        <currency-input
          v-model.number="monthlyIncome"
          :currency="activePlan.goalInfo.currency"
        />
      </div>

      <div class="ui field">
        <label>Current Investments</label>
        <currency-input
          v-model.number="activePlan.accounts[0].accountMarketValue"
          :currency="activePlan.goalInfo.currency"
        />
      </div>

      <div class="ui field">
        <label>Monthly Contribution </label>
        <currency-input
          v-model.number="
            activePlan.getContributionCashFlowRequest.contribution
          "
          :currency="activePlan.goalInfo.currency"
        />
      </div>
      <div class="ui message">
        <small>all these figures can be changed later</small>
      </div>
    </div>

    <div class="ui" v-if="part == 2">
      <h2>
        Risk Tolerance
        <span class="ui sub header">How willing are you to accept risk?</span>
      </h2>
      <br />

      <div class="ui field">
        <label>Risk Return Trade off?</label>
        <currency-input
          v-model.number="activePlan.getIncomeCashFlowRequest.income"
          :currency="activePlan.goalInfo.currency"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import { getGoalTypes } from "@/gateway.js";
export default {
  name: "GoalTypes",
  components: { vSelect, VueSlider },
  props: ["activePlan"],
  data() {
    return {
      timeHorizon: 65,

      part: 1,
      monthlyIncome: 20000,
    };
  },
  watch: {
    timeHorizon() {
      // set satrt year of income & goal target age.
      this.activePlan.getContributionCashFlowRequest.contributionStartYear = this.activePlan.getIncomeCashFlowRequest.currentAge;
      this.activePlan.getContributionCashFlowRequest.contributionToLast = this.timeHorizon; // - this.activePlan.getIncomeCashFlowRequest.currentAge + this.timeHorizon;

      this.activePlan.getIncomeCashFlowRequest.startYear = this.timeHorizon + 1;
      this.activePlan.goalInfo.goalTargetAge = this.timeHorizon;

      this.activePlan.getIncomeCashFlowRequest.income =
        this.monthlyIncome *
        Math.round(
          Math.pow(
            1.055,
            this.timeHorizon +
              1 -
              this.activePlan.getIncomeCashFlowRequest.currentAge
          ),
          0
        );
    },
    monthlyIncome() {
      this.activePlan.getIncomeCashFlowRequest.startYear = this.timeHorizon + 1;
      // income to last for how many years
      this.activePlan.getIncomeCashFlowRequest.income =
        this.monthlyIncome *
        Math.round(
          Math.pow(
            1.055,
            this.timeHorizon +
              1 -
              this.activePlan.getIncomeCashFlowRequest.currentAge
          ),
          0
        );
    },
  },
  computed: {},
  methods: {
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
  },
  mounted() {
    this.timeHorizon = this.activePlan.getContributionCashFlowRequest.contributionToLast;
    this.monthlyIncome =
      this.activePlan.getIncomeCashFlowRequest.income /
      Math.pow(
        1.055,
        this.timeHorizon +
          1 -
          this.activePlan.getIncomeCashFlowRequest.currentAge
      );
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
